// extracted by mini-css-extract-plugin
module.exports = {"shareBlockShowOnHover":"ShareBlock_shareBlockShowOnHover__kGWga","noText":"ShareBlock_noText__ArGUC","mediumIconSize":"ShareBlock_mediumIconSize__yG5DZ"};